import { getValue, compareValue, parseDate } from '../utils/formValue';
export default function initDateAtLeastXDaysInTheFuture() {

    $.validator.addMethod("atleastxdays",
        function (value, element, params) {
            if (parseDate(value) == null) { return true; } //Continue if not parsed correctly. let date.js handle this

            var result = compareValue(
                value,
                "GreaterThanEqual",
                params["days"],
                "System.DateTime",
                params
            );
            
            return result;
        })


    $.validator.unobtrusive.adapters.add("atleastxdays", ["days", "dateformat"],
        function (options) {
            options.rules['atleastxdays'] =
            {
                days: options.params.days,
                dateformat: options.params.dateformat,
            };
            options.messages['atleastxdays'] = options.message;
        }
    );
}